import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

const TERMINAL = ["Completed", "Partially Completed", "Failed", "Cancelled"];

export const newIdemKey = () =>
  (typeof crypto !== "undefined" && crypto.randomUUID
    ? crypto.randomUUID()
    : `idem-${Date.now()}-${Math.random().toString(36).slice(2)}`);

export const idemHeaders = (key) => ({ headers: { "Idempotency-Key": key } });

// Poll a marketing generation job until it reaches a terminal state.
export async function pollJob(jobId, { onUpdate, interval = 2000, timeout = 240000 } = {}) {
  const start = Date.now();
  // eslint-disable-next-line no-constant-condition
  while (true) {
    const { data } = await api.get(`/marketing/jobs/${jobId}`);
    if (onUpdate) onUpdate(data);
    if (TERMINAL.includes(data.status)) return data;
    if (Date.now() - start > timeout) throw new Error("This is taking longer than expected. It will keep running in the background.");
    await new Promise((r) => setTimeout(r, interval));
  }
}

export function jobErrorMessage(job) {
  const e = job?.error;
  if (!e) return "Generation failed.";
  return typeof e === "string" ? e : `${e.code || "error"}: ${e.message || "Generation failed."}`;
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
